// import _ from 'lodash';
import { SUBMIT_SELECTION_START, SUBMIT_SELECTION_SUCCESS, SUBMIT_SELECTION_FAIL } from 'client/constants';

// import { analytics } from 'common/utils';
import * as api from 'api';
import { resetItems } from './reset-items';

export function submitSelection({ categoryId, selectedItems, token }) {
	return async (dispatch, getState) => {
		try {
			dispatch({ type: SUBMIT_SELECTION_START, payload: { selectedItems } });

			// const {
			// 	items: { data: songs },
			// } = getState();
			// const songNames = _.map(selectedItems, id => _.get(songs, `${id}.songName`));

			// _.forEach(songNames, songName => analytics.onClickSongs(categoryId, songName));
			// analytics.onClickFinish(categoryId);

			dispatch(resetItems());
			const ls = window.localStorage;
			const userId = ls.getItem('__uid__v2');

			const result = await api.submitSelection({ userId, categoryId, selectedItems, token });

			// console.info('===== submitSelection =====', result);

			if (result.success) {
				const selectionData = JSON.parse(
					ls.getItem(`${categoryId}v2`) ||
						'{ "isSelectionSubmitted": false, isInfoSubmitted": false, "selectedItems": [] }'
				);

				selectionData.isSelectionSubmitted = true;
				selectionData.selectedItems = selectedItems;

				ls.setItem(`${categoryId}v2`, JSON.stringify(selectionData));

				dispatch({ type: SUBMIT_SELECTION_SUCCESS, payload: { categoryId, selectedItems } });
				return { selectedItems };
			}

			throw new Error(result.message);
		} catch (e) {
			dispatch({ type: SUBMIT_SELECTION_FAIL, payload: e.message });
		}

		return null;
	};
}
